import { buildPath } from "./buildPath";

export const circleAiSkills = {
  list: () => buildPath("/internal_api/circle_ai/skills"),
  show: ({ id }: { id: number }) =>
    buildPath(`/internal_api/circle_ai/skills/${id}`),
};
